export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-white py-24 md:py-36 px-6 md:px-16 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16 md:mb-20">
          <span className="text-emerald-500 text-xs font-semibold tracking-[0.2em] uppercase">Our Story</span>
          <h2 className="mt-3 text-3xl md:text-5xl font-bold text-[#1C1C1E] tracking-tight">About NOX, d.o.o.</h2>
          <div className="mt-6 w-14 h-0.5 bg-emerald-500 mx-auto rounded-full" />
        </div>

        {/* Two Column Layout */}
        <div className="flex flex-col lg:flex-row gap-12 md:gap-20 items-center">
          {/* Left — Image */}
          <div className="w-full lg:w-[45%] flex-shrink-0">
            <div className="relative rounded-2xl overflow-hidden w-full h-[320px] md:h-[460px]">
              <img
                src="https://public.readdy.ai/ai/img_res/5f056bf53bfbe89f18de7d29088351b0.jpg"
                alt="NOX Team"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-900/20 to-transparent" />

              {/* Floating Badge */}
              <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-sm rounded-xl px-5 py-3 flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center">
                  <img
                    src="https://public.readdy.ai/ai/img_res/d0159d21-72a5-4d01-bd23-06259d881c81.png"
                    alt="NOX Logo"
                    className="w-8 h-8 object-contain"
                  />
                </div>
                <div>
                  <p className="text-[#1C1C1E] font-bold text-sm leading-none">NOX, d.o.o.</p>
                  <p className="text-[#8E8E93] text-xs mt-0.5">Murska Sobota, Slovenia</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right — Content */}
          <div className="w-full lg:w-[55%]">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-1 h-16 bg-emerald-500 rounded-full flex-shrink-0 mt-1" />
              <p className="text-[#3A3A3C] text-base md:text-lg leading-[1.85] font-light">
                NOX, d.o.o. is a Slovenian technology company founded by a passionate team of mobile development experts with a singular mission: to create iOS applications that genuinely improve people's digital lives.
              </p>
            </div>

            <p className="text-[#6C6C70] text-sm md:text-base leading-[1.9] mb-5 font-light">
              Based in Murska Sobota, Slovenia, we combine European engineering precision with a deep understanding of modern mobile user behavior. Our team specializes exclusively in the iOS ecosystem, allowing us to deliver products that are tightly optimized for Apple's hardware and software.
            </p>
            <p className="text-[#6C6C70] text-sm md:text-base leading-[1.9] font-light">
              From our flagship VPN solution to our device optimization tool, every product we ship undergoes rigorous testing and refinement. We're committed to transparency, user privacy, and continuous improvement — values that are woven into everything we build.
            </p>


          </div>
        </div>
      </div>
    </section>
  );
}
